import { MatDialogRef } from '@angular/material/dialog';
import { TransportManagementProfileModel } from '../models/transport-management-profile.model';

export class TransportManagementProfileItemLoad {
  public static readonly type = '[TransportManagementProfileItem] Load';

  constructor(public payload: number) {}
}

export class TransportManagementProfileItemCreate {
  public static readonly type = '[TransportManagementProfileItem] Create';

  constructor(
    public payload: {
      dialog: MatDialogRef<unknown>;
      profile: Partial<TransportManagementProfileModel>;
    },
  ) {}
}

export class TransportManagementProfileItemUpdate {
  public static readonly type = '[TransportManagementProfileItem] Update';

  constructor(public payload: Partial<TransportManagementProfileModel>) {}
}

export class TransportManagementProfileItemInitialState {
  public static readonly type = '[TransportManagementProfileItem] Set Initial State';
}
